import { is } from '@wp-g2/utils';
import { css } from '../style-system';
/**
 * @param {{ height: import('create-emotion').ObjectInterpolation<any>['height'], width: import('create-emotion').ObjectInterpolation<any>['width'] }} options
 */

export var frame = function (_ref) {
  var height = _ref.height,
      width = _ref.width;
  var styles = [];

  if (is.defined(width)) {
    styles.push([css({
      maxWidth: '100%',
      width: width
    })]);
  }

  if (is.defined(height)) {
    styles.push([css({
      height: height,
      maxHeight: '100%'
    })]);
  }

  return css(styles);
};

frame.width = function (
/** @type {import('create-emotion').ObjectInterpolation<any>['width']} */
width) {
  return css({
    maxWidth: '100%',
    width: width
  });
};

frame.height = function (
/** @type {import('create-emotion').ObjectInterpolation<any>['height']} */
height) {
  return css({
    height: height,
    maxHeight: '100%'
  });
};